export const US_STATES = {
  AL: 'usState.name.alabama',
  AK: 'usState.name.alaska',
  AS: 'usState.name.americanSamoa',
  AZ: 'usState.name.arizona',
  AR: 'usState.name.arkansas',
  'UM-81': 'usState.name.bakerIsland',
  CA: 'usState.name.california',
  CO: 'usState.name.colorado',
  CT: 'usState.name.connecticut',
  DE: 'usState.name.delaware',
  DC: 'usState.name.districtOfColumbia',
  FL: 'usState.name.florida',
  GA: 'usState.name.georgia',
  GU: 'usState.name.guam',
  HI: 'usState.name.hawaii',
  'UM-84': 'usState.name.howlandIsland',
  ID: 'usState.name.idaho',
  IL: 'usState.name.illinois',
  IN: 'usState.name.indiana',
  IA: 'usState.name.iowa',
  'UM-86': 'usState.name.jarvisIsland',
  'UM-67': 'usState.name.johnstonAtoll',
  KS: 'usState.name.kansas',
  KY: 'usState.name.kentucky',
  'UM-89': 'usState.name.kingmanReef',
  LA: 'usState.name.louisiana',
  ME: 'usState.name.maine',
  MD: 'usState.name.maryland',
  MA: 'usState.name.massachusetts',
  MI: 'usState.name.michigan',
  'UM-71': 'usState.name.midwayAtoll',
  MN: 'usState.name.minnesota',
  MS: 'usState.name.mississippi',
  MO: 'usState.name.missouri',
  MT: 'usState.name.montana',
  'UM-76': 'usState.name.navassaIsland',
  NE: 'usState.name.nebraska',
  NV: 'usState.name.nevada',
  NH: 'usState.name.newHampshire',
  NJ: 'usState.name.newJersey',
  NM: 'usState.name.newMexico',
  NY: 'usState.name.newYork',
  NC: 'usState.name.northCarolina',
  ND: 'usState.name.northDakota',
  MP: 'usState.name.northernMarianaIslands',
  OH: 'usState.name.ohio',
  OK: 'usState.name.oklahoma',
  OR: 'usState.name.oregon',
  'UM-95': 'usState.name.palmyraAtoll',
  PA: 'usState.name.pennsylvania',
  PR: 'usState.name.puertoRico',
  RI: 'usState.name.rhodeIsland',
  SC: 'usState.name.southCarolina',
  SD: 'usState.name.southDakota',
  TN: 'usState.name.tennessee',
  TX: 'usState.name.texas',
  UM: 'usState.name.unitedStatesMinorOutlyingIslands',
  VI: 'usState.name.unitedStatesVirginIslands',
  UT: 'usState.name.utah',
  VT: 'usState.name.vermont',
  VA: 'usState.name.virginia',
  'UM-79': 'usState.name.wakeIsland',
  WA: 'usState.name.washington',
  WV: 'usState.name.westVirginia',
  WI: 'usState.name.wisconsin',
  WY: 'usState.name.wyoming'
}
